import template from './mobile_app.html';
import controller from './mobile_app.controller';
import './mobile_app.scss';

let mobileAppComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
};

export default mobileAppComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/mobile_app.component.js